<template>
<div>
    <smallbutton toplabel="Add Admin Transaction" @click="startAdd()" v-if="showButton" :class="buttonclass"/>
    <linkbutton toplabel="Add Admin Transaction" @click="startAdd()" v-if="!showButton"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">Add Transaction for {{AdminFundRequest.Name}}</label>
                <br/>
                
                <formentry inputid="amount"  isrequired="True" label="Transaction Amount $"  v-model="AdminFundRequest.newAmount" inputtype="number"  />
                <formentry inputid="date" inputtype="date"  label="Effective Date"  v-model="AdminFundRequest.effectiveDate" isrequired='True'/>
                <formentry inputid="reason"  label="Reason"  v-model="AdminFundRequest.Reason" isrequired="True" />
                
                <div class="entry" v-if="showWalletTokenTypes">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="tokenselect">Payment Type</label>
                    </div>
                    <select name="" id="tokenselect" class='entrySelect' v-model="AdminFundRequest.walletTokenTypeId" required>
                        <option v-for="w in walletTokenTypeList" :key="w.id" :value="w.id" >
                            {{w.name}}
                        </option>
                    </select>
                </div>

                <div>
                    <label for="" class="required">{{requiredFieldLabel}}</label>
                </div>
                <smallbutton  @click="ConfirmAddTransaction()" toplabel="Save" :disabled="isSaved" />
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
                
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from '../controls/actionmodal.vue'
import formentry from '../controls/entry.vue'
export default {
    name:'addadmintrans',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton
    },
    props:{
        accountId:{
            type:Number,
            required:true
        },
        showButton:{
            type:Boolean,
            default:false
        },
        buttonclass:{
                type:String,
                default:"button buttonprimary"
            },
        
    },
    mixins:[datamethods,format],
    data(){
        return{
            isSaved:false,
            insave:false,
            responseMessage:'',
            pleaseWait:false,
            AdminFundRequest:{
                Name:'',
                fromAccount:0,
                toAccount:0,
                oldAmount:'',
                newAmount:'',
                Reason:'',
                effectiveDate:'',
            },
            walletTokenTypeList:[]
            
        }
    },
    computed:{
        ...mapFields([
            'disableAddFunds',
            'currentWallet',
            'loggedInUser'

        ]),
        showWalletTokenTypes(){
            if(window.SHOW_WALLETTOKENTYPE_ON_ADMINTRANS==undefined){return false}
            else{return window.SHOW_WALLETTOKENTYPE_ON_ADMINTRANS}
        }
    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        startAdd(){
            var dt = this.$options.filters.formatDateForInputToday();
            this.AdminFundRequest={
                Name:'',
                fromAccount:0,
                toAccount:0,
                oldAmount:'',
                newAmount:'',
                Reason:'',
                effectiveDate:dt
            }   
            this.AdminFundRequest.oldAmount=0;
            //this.AdminFundRequest.Name=this.account.Name;
            this.AdminFundRequest.fromAccount=this.accountId;
            this.AdminFundRequest.employeeId=this.loggedInUser.user_personId;

            if(this.showWalletTokenTypes){this.getWalletTokenTypes()}

            this.$refs.mymodal.openModal()
        },
        async ConfirmAddTransaction(){
            if(this.insave){return}
            this.insave=true
            if(this.$refs.balform.checkValidity()){
                this.beforeAPI();
                let req = {
                    adminfunds:this.AdminFundRequest,
                }
                var response = await this.callAPI(req,'addtransaction')

                if(response.Successful){
                     this.insave=false
                    this.isSaved=true
                    this.responseMessage="Add Transaction was successful"
                    this.$emit('refresh')
                }else{
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
            }
        },

       async getWalletTokenTypes(){
            
            //setup request
            let req = {
             
            }
            //call api
            this.beforeAPI();
            var response = await this.callAPI(req,'wallettokentype_admin')
            //handle response
            if(response.Successful){
                this.walletTokenTypeList=response.list
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        
       
        
    }
}
</script>

<style>

</style>





























